import {EJsBridge} from '../Enums/jsBridge';
import { _getItemFromLocal, _removeItemFromLocal } from './LocalKeys';

interface IData {
    type: string,
    data?: string | number | Blob
} 

type IEnhancedWindow  = {
    webkit: {
        messageHandlers: {
            callback:{
                postMessage: (data: string) => {}
            }
        }
    }
    callback:{
        postMessage: (data: string) => {}
    }
    ReactNativeWebView?: {
        postMessage: (message: string) => void;
    };
}

let enhancedWindow = window as Window & typeof globalThis & IEnhancedWindow;

export const _hasBridgeHelper = async (data: IData) => {

    		
    if (
        enhancedWindow.ReactNativeWebView &&
        enhancedWindow.ReactNativeWebView.postMessage
      ) {
        // Post message to React Native WebView
        await enhancedWindow.ReactNativeWebView.postMessage(btoa(JSON.stringify(data)));
        return true
    }


    if (enhancedWindow.webkit != undefined && enhancedWindow.webkit.messageHandlers !== undefined && enhancedWindow.webkit.messageHandlers.callback !== undefined && enhancedWindow.webkit.messageHandlers.callback.postMessage !== undefined) {
        await enhancedWindow.webkit.messageHandlers.callback.postMessage(btoa(JSON.stringify(data)));
        return true;
    }
    else if (enhancedWindow.callback != undefined) {
        await enhancedWindow.callback.postMessage(btoa(JSON.stringify(data)));
        return true;
    }
    else {
        return false;
    }
}

interface IMailData {
    subject?:string,
    body?:string,
    email_id?:string
}

export const mailtoIntentHandler = async (mailData:IMailData) => {
    
    const mailBody = {
        type: EJsBridge.MAIL,
        ...mailData
    }
    
    return await _hasBridgeHelper(mailBody)
}

interface ItelephoneData {
    value?:number
}

export const telephoneIntentHandler = async (telephoneData:ItelephoneData) => {

    const telephoneBody = {
        type: EJsBridge.TELEPHONE,
        ...telephoneData
    }

    return await _hasBridgeHelper(telephoneBody)
}

interface IFileShareData {
    value?:Blob
}

export const fileShareIntentHandler = async (fileShareData:IFileShareData) => {

    const fileShareDataBody = {
        type: EJsBridge.SHARE_DATA,
        ...fileShareData
    }

    return await _hasBridgeHelper(fileShareDataBody)
}

export const validationTokenHanlder = async () => {

    const validationTokenBody = {
        type: EJsBridge.VALIDATIOIN_TOKEN
    }

    return await _hasBridgeHelper(validationTokenBody)
}

interface IWhatsappData {
    phone_number?: number|string,
    text?: string,
    value?: string
}

export const whatsappIntentHanlder = async (whatsappData: IWhatsappData) => {

    const whatsappDataBody = {
        type: EJsBridge.WHATSAPP,
        ...whatsappData
    }

    return await _hasBridgeHelper(whatsappDataBody)
}

export const backIntentHanlder = async () => {

    const backIntentBody = {
        type: EJsBridge.BACK,
    }

    return await _hasBridgeHelper(backIntentBody)
}

export const closeIntentHanlder = async () => {

    const backIntentBody = {
        type: EJsBridge.CLOSE,
    }

    const response = await _hasBridgeHelper(backIntentBody);
    if(_getItemFromLocal("_ru")) {
        _removeItemFromLocal("_ru");
    }
    return response;
}

interface IApiErrorIntentData {
    value?: string,
    error_code?: string
}

export const apiErrorIntentHanlder = async (apiErrorBody: IApiErrorIntentData) => {

    const apiErrorIntentBody = {
        type: EJsBridge.API_ERROR,
        ...apiErrorBody
    }

    return await _hasBridgeHelper(apiErrorIntentBody)
}

interface IAuthorizationErrorIntentData {
    value?: string,
    error_code?: string
}

export const authorizationErrorIntentHandler = async (authorizationErrorBody: IAuthorizationErrorIntentData) => {

    const authorizationErrorIntentBody = {
        type: EJsBridge.AUTHORIZATION_ERROR,
        ...authorizationErrorBody
    }

    return await _hasBridgeHelper(authorizationErrorIntentBody)
}

export const loadingCompletedIntentHanlder = async () => {

    const backIntentBody = {
        type: EJsBridge.LOADING_COMPLETED,
    }

    return await _hasBridgeHelper(backIntentBody)
}

interface ISendColorStatus {
    borderColor: string; 
}

export const sendColorHandler = async (colorStatusBody: ISendColorStatus) => {

    const colorStatusIntentBody = {
        type: EJsBridge.SEND_COLOR_STATUS,
        ...colorStatusBody
    }

    return await _hasBridgeHelper(colorStatusIntentBody)
}